/**
 * 推荐广告位模块
 * 设计文档：https://lark.alipay.com/jingcheng.pjc/pjc625/mmm2mh
 * 迭代方式：继承advert.js后，重写SetDOM函数并注册事件即可。统计上报可按照advert.js的统计上报函数中的query class添加。在本脚本的CreateWhichAdvertDOM中增加触发判断。
 * 数据来源：参考页面上的https://gds.9game.cn/gd.getslot jsonp脚本。接口文档：https://doc.9game.ucweb.local/pages/viewpage.action?pageId=4391706
 * advert.js的子类机制已经比较完善了。抠了静态结构进来基本不用考虑本地调试，prerelease后脚本放到预发布环境测试。
 * 如果需要本地调试，需注意:
 *  advert.js中请求了门户后端基础数据。本地跨域，请将地址更换为localhost下的public/advert/ajax。
 *  本脚本中有请求https://gds.9game.cn/gd.getslot jsonp。需要传一个sid进去，可以额外添加一个默认值。
 * ps.样式上有前人挖的一些坑，上了预发环境估计需要多调一下。
 */
// require('./index.scss');
const Stat = require('public/stat');
const md5Hex = require('md5-hex');
const AdvertOne = require('./module/advert_one');
const AdvertTwo = require('./module/advert_two');
const AdvertThree = require('./module/advert_three');
const AdvertFourOne = require('./module/advert_four_row');
const AdvertFourTwo = require('./module/advert_four_col');
const AdvertFive = require('./module/advert_five');
const AdvertVideoOne = require('./module/advert_video_one');
const AdvertVideoTwo = require('./module/advert_video_two');
const AdvertArticle = require('./module/advert_article');
const AdvertOldTypeTwo = require('./module/advert_old_type_two');
const AdvertOldTypeThree = require('./module/advert_old_type_three');
const AdvertOldTypeFour = require('./module/advert_old_type_four');
// const Pullup = require('@ali/aliplay-pullup');
const AdvertNOne = require('./module/advert_n_one');
const AdvertNTwo = require('./module/advert_n_two');
const AdvertNThree = require('./module/advert_n_three');
const AdvertNFour = require('./module/advert_n_four');
const AdvertNFive = require('./module/advert_n_five');

const IsBaidu = function() {
  if (window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf('baidu') > -1) {
    return 1;
  } else {
    return 0;
  }
};
class Module {
  constructor() {
    // 广告位ID
    this.TEXT_TOP_GID = 1335; // 资讯上部 id: 1335,836
    this.TEXT_MIDDLE_GID = 1336; // 资讯中部 id: 1336,837
    this.TEXT_BOTTOM_GID = 1337; // 资讯下部 id: 1337,838
    this.ARTICLE_GID = 2285; // 信息流

    this.GD_params;
    this.AdMap = { // 广告位对应的id和DOM位置,如果需要增加广告位请参考这里
      textTop: {
        id: this.TEXT_TOP_GID,
        $dom: this.$textTop,
      },
      textMiddle: {
        id: this.TEXT_MIDDLE_GID,
        $dom: this.$textMiddle,
      },
      textBottom: {
        id: this.TEXT_BOTTOM_GID,
        $dom: this.$textBottom,
      },
      article: {
        id: this.ARTICLE_GID,
        $dom: this.$article
      }
    };
    this.init();
  }

  get Sid() {
    // ut || sid
    return Stat.getCookie('ut') || Stat.getCookie('sid');
  }

  get $textBottom() {
    let $root = $('.article-content');
    if (this.IsInPc()) {
      $root = $('.text-con').length > 0 ? $('.text-con') : $('.post-content');
    }
    const $textBottom = $('<div></div>');
    $root.append($textBottom);
    return $textBottom;
  }

  get $textTop() {
    let $root = $('.article-content');
    if (this.IsInPc()) {
      $root = $('.text-con').length > 0 ? $('.text-con') : $('.post-content');
    }
    const $textTop = $('<div></div>');
    $root.prepend($textTop);
    return $textTop;
  }

  get $article() {
    if ($('.gameInformation').length > 0) {
      return $('.gameInformation').find('.news-item').eq(2);
    } else {
      return $('.game-article-main').find('.game-article-li').eq(2);
    }
  }

  get $textMiddle() {
    let $root = $('.article-content');
    if (this.IsInPc()) {
      $root = $('.text-con').length > 0 ? $('.text-con') : $('.post-content');
    }
    const $p = $root.find('p');
    if (!$p) {
      const text = $root.text();
      $root.html(`${text.slice(0, text.length / 2)}<div class='ad-sort-port'></div>${text.slice(text.length / 2, text.length)}`);
      return $root.find('.ad-sort-port');
    }
    const children = [];
    $p.each(function(i, e) {
      if (typeof $(e).attr('style') === 'string') return;
      children.push($(e));
    });
    let $target = null;
    if (children.length === 1) {
      $target = children[0];
    } else {
      $target = children[ Math.round(children.length / 2)];
    }
    return $target;
  }

  IsInPc() {
    return !!location.host.match('www.9game.cn');
  }
  // 公共拉起
  pullUp(gameId, pullUpFrom, ch, isDownload) {
    const opt = isDownload ? 'download' : 'reserve';
    NineGameClientPullUp.wakeup({
      pageType: 'game_detail', // 需要拉起页面 pageType
      opt,
      gameId,
      ch,
      checkTime: 200,
      pullUpFrom, // 拉起来源
    }, function(error, update, result) {
      // Stat.StatHightSpeedDownload(gameId);
      if (!error) {
        console.log('拉起成功');
      } else {
        if (update) {
          console.log('拉起失败, 需升级, 下载地址: ' + result);
          location.href = result;
        } else {
          console.log('拉起失败, 未安装, 下载地址: ' + result);
          location.href = result;
        }
      }
    });
  }
  // 向中台发送请求获取广告信息
  AjaxGetAdData(data) {
    const caller = 'gds_portal';
    const self = this;
    // const sign = md5Hex(caller + 'adpIds=' + data.adpIds + 'divId=' + data.divId + 'odId=' + data.odId + 'odPlatformId=' + data.odPlatformId + 'odType=' + data.odType + 'odSource=' + data.odSource + 'odCollectIds=' + data.odCollectIds + 'odKeyword=' + data.odKeyword + 'odRemark=' + data.odRemark + 'odGameId=' + data.odGameId);
    const sign = md5Hex(caller + 'adpIds=' + data.adpIds + 'divId=' + data.divId + 'sid=' + self.Sid);
    return new Promise(function(resolve, reject) {
      $.ajax({
        type: 'GET',
        url: '//gds.9game.cn/gd.getslot',
        dataType: 'jsonp',
        jsonpCallback: 'UC_GD_SETJSONSLOT',
        data: {
          caller,
          id: '',
          'data.adpIds': data.adpIds,
          'data.divId': data.divId,
          'data.odId': data.odId,
          'data.odPlatformId': data.odPlatformId,
          'data.odType': data.odType,
          'data.odSource': data.odSource,
          'data.odCollectIds': data.odCollectIds,
          'data.odKeyword': data.odKeyword,
          'data.odRemark': data.odRemark,
          'data.odGameId': data.odGameId,
          'data.sid': self.Sid,
          'data.recGameId': data.recGameId,
          sign,
        },
        success(res) {
          resolve(res);
        },
        error(error) {
          reject(error);
        }
      });
    });
  }
  // 初始化
  init() {
    window.UC_GD_fillOdSlotAsync2 = (adpIds, divId, odId, odPlatformId, odType, odSource, odCollectIds, odKeyword, odRemark, odGameId, zxbj, recGameId) => {
      let adpIdss = `${this.TEXT_TOP_GID},${this.TEXT_MIDDLE_GID},${this.TEXT_BOTTOM_GID},${this.ARTICLE_GID}`;
      const _gdcontenthide = $('#_gdcontenthide').val() || '0';
      // 资讯排行榜会由服务端做下载按钮配置，前端广告不请求资讯内容相关的广告信息
      if (_gdcontenthide === '1') {
        adpIdss = `${this.ARTICLE_GID}`;
      }
      const params = {
        adpIds: adpIdss,
        divId,
        odId,
        odPlatformId,
        odType,
        odSource,
        odCollectIds,
        odKeyword,
        odRemark,
        odGameId,
        zxbj,
        recGameId,
      };
      this.GD_params = params;
      this.GD_params.ut = this.Sid;
      this.AjaxGetAdData(params).then((data) => {
        this.CreateWhichAdvertDOM(data);
      }).catch((error) => {
        console.error(error);
      });
    };
    this.SetStateFromPage();
    // this._initUseHighSpeedDownload();
    // 移动端的360浏览器会拦截script创建导致发行数据无法正确获取，影响到加完广告位后的下了又下效果
    // 针对360浏览器的处理。但是在其他浏览器无影响
    if (this.IsInPc()) return;
    require('public/recommend').callback = () => {
      $('.article-content').find('.game-download.count-download').attr('href', null).attr('btn', null).on('click', e => {
        const gameId = $(e.target).closest('.game-list-item.count-list-item').data('gameId');
        this.pullUp(gameId, `ag_ugt-seo-nrzrgg-zx_${adCard.GD_params.odId}-gd_${adCard.admData.adpId}-wl_${adCard.admData.admId}-gid_${adCard.admData.gameId}`, 'OK_218');
      });
    };
  }

  // 处理生成哪些广告位卡片
  CreateWhichAdvertDOM(res) {
    const dataArray = _.get(res, 'data.adps');
    const length = dataArray.length;
    if (length === 0 && (!this.IsInPc())) {
      require('public/recommend');
    }
    for (const i in this.AdMap) {
      dataArray.forEach((data, k) => {
        if (this.AdMap[ i ].id !== data.adpId) return;
        let AD;
        const mapPosition = this.AdMap[ i ];
        data.GD_params = this.GD_params;
        switch (data.adpType) {
          case 2:
            AD = new AdvertOldTypeTwo();
            break;
          case 3:
            AD = new AdvertOldTypeThree();
            break;
          case 4:
            AD = new AdvertOldTypeFour();
            break;
          case 5:
            AD = new AdvertArticle();
            break;
          case 6:
            switch (data.adms[ 0 ].styleId) {
              case 1:
                AD = new AdvertOne();
                break;
              case 2:
                AD = new AdvertTwo();
                break;
              case 3:
                AD = new AdvertThree();
                break;
              case 4:
                if (data.adms[ 0 ].extension) {
                  try {
                    if (JSON.parse(data.adms[ 0 ].extension).style === '1') {
                      AD = new AdvertFourOne();
                    } else {
                      AD = new AdvertFourTwo();
                    }
                  } catch (error) {
                    AD = new AdvertFourOne();
                  }
                } else {
                  AD = new AdvertFourOne();
                }
                break;
              case 5:
                AD = new AdvertFive();
                break;
              case 6:
                AD = new AdvertNOne();
                break;
              case 7:
                AD = new AdvertNTwo();
                break;
              case 8:
                AD = new AdvertNThree();
                break;
              case 9:
                AD = new AdvertNFour();
                break;
              case 10:
                AD = new AdvertNFive();
                break;
              default:
                break;
            }
            break;
          case 7:
            switch (data.adms[ 0 ].styleId) {
              case 1:
                AD = new AdvertVideoOne();
                break;
              case 2:
                AD = new AdvertVideoTwo();
                break;
              default:
                break;
            }
            break;
          default:
            break;
        }
        if (!AD) return;
        AD.Data = data;
        this.PlantAdvertDOMToPage(mapPosition.$dom, AD);
      });
    }
  }
  // 将广告位卡片植入页面
  PlantAdvertDOMToPage($brother, adCard) {
    adCard.AsyncDOM.then((res) => {
      $brother.before(res);
      // adCard.SetStateEvent();
      adCard.SetAgStatEvent();
      // 移动端的360浏览器会拦截script创建导致发行数据无法正确获取，影响到加完广告位后的下了又下效果
      if (this.IsInPc()) return;
      require('public/recommend').callback = () => {
        $('.article-content').find('.game-download.count-download').attr('href', null).attr('btn', null).on('click', e => {
          const gameId = $(e.target).closest('.game-list-item.count-list-item').data('gameId');
          this.pullUp(gameId, `ag_ugt-seo-nrzrgg-zx_${adCard.GD_params.odId}-gd_${adCard.admData.adpId}-wl_${adCard.admData.admId}-gid_${adCard.admData.gameId}`, 'OK_218');
        });
      };
    }).catch(function(error) {
      console.error(error);
    });
  }
  // 初始化页面上同步的广告位曝光
  SetStateFromPage() {
    $('.gd-ad2-explore').each(function(i, e) {
      const str = $(e).attr('gd-stat');
      const originParams = {};
      str.split(';').forEach(function(e) {
        const key = e.split(':')[ 0 ];
        const val = e.split(':')[ 1 ];
        originParams[ key ] = val;
      });
      delete originParams.ut;
      const exploreParams = { action: 'recsys_show', ac: 'recsys_show', a2: 'ag_gd_advert_2' };
      _.assign(exploreParams, originParams);
      // Stat.ExplorePortal($(e), exploreParams, 'ad');
    });
    window.setTimeout(function() {
      $('.gd-ad2-stat-recsys-click').on('click', function(e) {
        const str = $(this).attr('gd-stat');
        const originParams = {};
        str.split(';').forEach(function(e) {
          const key = e.split(':')[ 0 ];
          const val = e.split(':')[ 1 ];
          originParams[ key ] = val;
        });
        delete originParams.ut;
        const params = { action: 'recsys_click', ac: 'recsys_click', a2: 'ag_gd_advert_2' };
        _.assign(params, originParams);
        // Stat.StatPortal(params, 'ad');
      }, false);

      $('.gd-ad2-stat-recsys-down').on('click', function(e) {
        const str = $(this).attr('gd-stat');
        const originParams = {};
        str.split(';').forEach(function(e) {
          const key = e.split(':')[ 0 ];
          const val = e.split(':')[ 1 ];
          originParams[ key ] = val;
        });
        delete originParams.ut;
        const params = { action: 'recsys_down', ac: 'recsys_down', a2: 'ag_gd_advert_2' };
        _.assign(params, originParams);
        // Stat.StatPortal(params, 'ad');
      }, true);

      $('.gd-ad2-stat-recsys-app-down').on('click', function(e) {
        const str = $(this).attr('gd-stat');
        const originParams = {};
        str.split(';').forEach(function(e) {
          const key = e.split(':')[ 0 ];
          const val = e.split(':')[ 1 ];
          originParams[ key ] = val;
        });
        delete originParams.ut;
        const params = { action: 'recsys_app_down', ac: 'recsys_app_down', a2: 'ag_gd_advert_2' };
        _.assign(params, originParams);
        // Stat.StatPortal(params, 'ad');
      }, true);
    }, 1000);
  }
  // 初始化同步广告位的高速下载勾选
  _initUseHighSpeedDownload() {
    const $hotGame = $('.game-inner').find('.game-recommend-download');
    const $hotSelectBtn = $('.game-inner').find('.select-btn');
    const hotGameAgDataStat = $hotGame.attr('ag-data-stat');
    const isRecommendGameHighDown = function(state) {
      const $recommendDownload = $('.newGame-item').hasClass('newGame-item') ? $('.newGame-item').find('.game-recommend-download') : $('.normal-app-list').find('.game-recommend-download');
      $recommendDownload.each(function(i, e) {
        const rdagDataStat = $(e).attr('ag-data-stat');
        if (state) {
          if (IsBaidu() === 1) {
            $(e).addClass('pre-high-download').text('高速').attr('href', '');
          } else {
            $(e).addClass('pre-high-download').text('高速下载').attr('href', '');
          }
          if (rdagDataStat) {
            $(e).attr('ag-data-stat', rdagDataStat.replace('ag_ct:down;', 'ag_ct:quick_down;'));
          }
        } else {
          if (IsBaidu() === 1) {
            $(e).removeClass('pre-high-download').text('').attr('href', $(e).data('normal'));
          } else {
            $(e).removeClass('pre-high-download').text('下载').attr('href', $(e).data('normal'));
          }
          if (rdagDataStat) {
            $(e).attr('ag-data-stat', rdagDataStat.replace('ag_ct:quick_down;', 'ag_ct:down;'));
          }
        }
      });
      const highClass = $hotGame.hasClass('pre-download') ? 'pre-download' : 'pre-high-download';
      !state ? $hotSelectBtn.removeClass('select') : $hotSelectBtn.addClass('select');
      if (!state) {
        if (IsBaidu() === 1) {
          $hotGame.removeClass(highClass).text('').attr('href', $hotGame.data('normal'));
        } else {
          $hotGame.removeClass(highClass).text('下载').attr('href', $hotGame.data('normal'));
        }
        if (hotGameAgDataStat) {
          $hotGame.attr('ag-data-stat', hotGameAgDataStat.replace('ag_ct:quick_down;', 'ag_ct:down;'));
        }
      } else {
        if (IsBaidu() === 1) {
          $hotGame.addClass(highClass).text('高速').attr('href', '');
        } else {
          $hotGame.addClass(highClass).text('高速下载').attr('href', '');
        }
        if (hotGameAgDataStat) {
          $hotGame.attr('ag-data-stat', hotGameAgDataStat.replace('ag_ct:down;', 'ag_ct:quick_down;'));
        }
      }
    };
    isRecommendGameHighDown(true);

    $hotGame.hasClass('pre-high-download') || $hotGame.hasClass('pre-download') ? $hotSelectBtn.addClass('select') : $hotSelectBtn.removeClass('select');
    // 其他玩家都在玩推荐
    window.setTimeout(function() {
      $('.download-select-recommend').find('.select-btn').on('click', function() {
        const btn = $(this);
        const checkState = btn.hasClass('select');
        checkState ? btn.removeClass('select') : btn.addClass('select');
        checkState ? isRecommendGameHighDown(false) : isRecommendGameHighDown(true);
        return false;
      });
    }, 2000);

    // 热门推荐
    $hotSelectBtn.on('click', function() {
      const btn = $(this);
      const checkState = btn.hasClass('select');
      const highClass = $hotGame.hasClass('pre-download') ? 'pre-download' : 'pre-high-download';
      checkState ? btn.removeClass('select') : btn.addClass('select');
      if (checkState) {
        if (IsBaidu() === 1) {
          $hotGame.removeClass(highClass).text('').attr('href', $hotGame.data('normal'));
        } else {
          $hotGame.removeClass(highClass).text('下载').attr('href', $hotGame.data('normal'));
        }
        if (hotGameAgDataStat) {
          $hotGame.attr('ag-data-stat', hotGameAgDataStat.replace('ag_ct:quick_down;', 'ag_ct:down;'));
        }
      } else {
        if (IsBaidu() === 1) {
          $hotGame.addClass(highClass).text('高速').attr('href', '');
        } else {
          $hotGame.addClass(highClass).text('高速下载').attr('href', '');
        }
        if (hotGameAgDataStat) {
          $hotGame.attr('ag-data-stat', hotGameAgDataStat.replace('ag_ct:down;', 'ag_ct:quick_down;'));
        }
      }
      return false;
    });
  }
}
module.exports = new Module();


// WEBPACK FOOTER //
// ./lib/js/module/m_advert/index.js